<template>
  <div class="row align-center destaques_desktop" v-if="topNoticias.length > 2">
    <div class="small-12 medium-10 large-9 columns content galeria">
      <div class="row">
        <div class="small-12 medium-12 large-12 columns">
          <div class="destaques_galeria">
            <div class="row">
              <div class="large-6 columns" @click="goToDestaque(0)">
                <div class="galeria1"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[0]?.imagem+')'}">
                  <div class="layer"></div>
                  <p :class="{'show': topNoticias[0]?.imagem.length == 0 }">
                    {{topNoticias[0]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="large-3 columns" @click="goToDestaque(1)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[1]?.imagem+')'}">
                  <div class="layer"></div>
                  <p :class="{'show': topNoticias[1]?.imagem.length == 0 }">
                    {{topNoticias[1]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="large-3 columns" @click="goToDestaque(2)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[2]?.imagem+')'}">
                  <div class="layer"></div>
                  <p :class="{'show': topNoticias[2]?.imagem.length == 0 }">
                    {{topNoticias[2]?.titulo}}
                  </p>
                </div>
              </div>
            </div>
            <div class="row" v-if="topNoticias.length > 5">
              <div class="large-3 columns" @click="goToDestaque(3)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[3]?.imagem+')'}">
                  <div class="layer"></div>
                  <p :class="{'show': topNoticias[3]?.imagem.length == 0 }">
                    {{topNoticias[3]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="large-3 columns" @click="goToDestaque(4)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[4]?.imagem+')'}">
                  <div class="layer"></div>
                  <p :class="{'show': topNoticias[4]?.imagem.length == 0 }">
                    {{topNoticias[4]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="large-6 columns" @click="goToDestaque(5)">
                <div class="galeria1"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[5]?.imagem+')'}">
                  <div class="layer"></div>
                  <p :class="{'show': topNoticias[5]?.imagem.length == 0 }">
                    {{topNoticias[5]?.titulo}}
                  </p>
                </div>
              </div>
            </div>
            <botao2
                class="btnvermais"
                :background-color="this.color"
                :border-color="this.color"
                :text-color="this.color"
                @click="verTodasNoticias">
                  {{ $translate("UMA_LANG_DEPARTAMENTOS_VERMAIS") }}
            </botao2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-center destaques_mobile" v-if="topNoticias.length > 2">
    <div class="small-11 medium-10 large-9 columns content galeria">
      <div class="row">
        <div class="small-12 medium-12 columns">
          <div class="destaques_galeria">
            <div class="row">
              <div class="small-12 medium-6 columns" @click="goToDestaque(0)">
                <div class="galeria1"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[0]?.imagem+')'}">
                  <div class="layer" :class="{'show': topNoticias[0]?.imagem.length == 0 }"></div>
                  <p :class="{'show': topNoticias[0]?.imagem.length == 0 }">
                    {{topNoticias[0]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="small-12 medium-6 columns" @click="goToDestaque(1)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[1]?.imagem+')'}">
                  <div class="layer" :class="{'show': topNoticias[1]?.imagem.length == 0 }"></div>
                  <p :class="{'show': topNoticias[1]?.imagem.length == 0 }">
                    {{topNoticias[1]?.titulo}}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="small-12 medium-6 columns" @click="goToDestaque(2)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[2]?.imagem+')'}">
                  <div class="layer" :class="{'show': topNoticias[2]?.imagem.length == 0 }"></div>
                  <p :class="{'show': topNoticias[2]?.imagem.length == 0 }">
                    {{topNoticias[2]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="small-12 medium-6 columns" @click="goToDestaque(3)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[3]?.imagem+')'}">
                  <div class="layer" :class="{'show': topNoticias[3]?.imagem.length == 0 }"></div>
                  <p :class="{'show': topNoticias[3]?.imagem.length == 0 }">
                    {{topNoticias[3]?.titulo}}
                  </p>
                </div>
              </div>
            </div>
            <div class="row" v-if="topNoticias.length > 5">
              <div class="small-12 medium-6 columns" @click="goToDestaque(4)">
                <div class="galeria1 small"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[4]?.imagem+')'}">
                  <div class="layer" :class="{'show': topNoticias[4]?.imagem.length == 0 }"></div>
                  <p :class="{'show': topNoticias[4]?.imagem.length == 0 }">
                    {{topNoticias[4]?.titulo}}
                  </p>
                </div>
              </div>
              <div class="small-12 medium-6 columns" @click="goToDestaque(5)">
                <div class="galeria1"
                     :class="colorClass"
                     :style="{'background-image' : 'url('+topNoticias[5]?.imagem+')'}">
                  <div class="layer" :class="{'show': topNoticias[5]?.imagem.length == 0 }"></div>
                  <p :class="{'show': topNoticias[5]?.imagem.length == 0 }">
                    {{topNoticias[5]?.titulo}}
                  </p>
                </div>
              </div>
            </div>
            <botao2
                class="btnvermais"
                :background-color="this.color"
                :border-color="this.color"
                :text-color="this.color"
                @click="verTodasNoticias">
              {{ $translate("UMA_LANG_DEPARTAMENTOS_VERMAIS") }}
            </botao2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import botao2 from '@/components/botao2.vue';

export default {
  name: "destaquesHome",
  components: {
    botao2,
  },
  props:["colorClass","color"],
  data(){
    return {
      topNoticias: []
    }
  },
  created() {
    this.getTopNoticias();
  },
  methods:{
    goToDestaque(index){
      window.location = this.topNoticias[index].url;
    },
    verTodasNoticias(){
      this.$router.push('noticias')
    },
    getTopNoticias(){
      const request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/destaques?idioma=${this.$store.state.language}&limit=6`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.topNoticias = data.map(el => {
              let ellipsedNome = el.Nome;
              if(ellipsedNome.length > 80){
                ellipsedNome = ellipsedNome.substring(0,80)+"(...)";
              }
              return {
                id: el.ID,
                titulo: ellipsedNome,
                corpo: el.Texto,
                imagem: el.Imagem,
                url: el.Url
              }
            });
          })
          .catch(error => console.log(error));
    }
  }
}
</script>

<style scoped>

.content {
  margin: 0 auto;
}

.galeria1 {
  height: 260px;
  border-radius: 8px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding-top: 46px;
  padding-left: 48px;
  padding-right: 10px;
  position: relative;
  transition: all .6s;
  line-height: 1.55;
  font-size: 22px;
}

.galeria1:hover{
  cursor: pointer;
}

.galeria1 .layer{
  background: rgba(0,0,0,0);
  transition: background .6s;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 8px;
  z-index: 1;
}

.galeria1:hover .layer{
  background: rgba(0,0,0,0.35);
  transition: background .6s;
}

.galeria1.small{
  padding-left: 10px;
  padding-right: 10px;
}

.galeria1 p{
  opacity: 0;
  color: white;
  transition: opacity .6s;
  font-family: Montserrat;
  z-index: 2;
  position: absolute;
  z-index: 2;
  font-size: 22px;
  line-height: 1.55;

}

.galeria1:hover p{
  opacity: 1;
  transition: opacity .6s;
}

.galeria1 p.show{
  opacity: 1;
  text-align: center;
  font-size: 22px;
  line-height: 1.55;
}

.destaques_galeria .row {
  padding-bottom: 12px;
}

.destaques_galeria .row .columns {
  padding-right: 6px;
  padding-left: 6px;
}

.destaques_galeria .row {
  margin-right: 0px;
  margin-left: 0px;
}

.galeria {
  padding-right: 0px;
  padding-left: 0px;
}

.galeria .row {
  margin-right: 0px;
  margin-left: 0px;
}

.galeria1.small  {
  padding-left: 30px;
  padding-right: 10px;

}

.galeria1.small.show {
  padding-right: 35px;
  padding-left: 30px;
}

.galeria1 p.show {
  margin-right: 40px;
  margin-left: 13px;
}

.destaques_desktop {
  display: block;
}

.destaques_mobile {
  display: none;
}

.btnvermais{
  margin: 15px auto 0;
}

/*Responsive - ipad*/
@media (max-width: 1025px) {

  .destaques_desktop {
    display: none;
  }

  .destaques_mobile {
    display: block;
  }

  .destaques_mobile .destaques_galeria .row .columns {
    padding-left: 3px;
    padding-right: 3px;
  }

  .destaques_mobile .destaques_galeria .row {
    padding-bottom: 6px;
  }

  .destaques_mobile .galeria1 .layer {
    position: absolute;
    background: rgba(0,0,0,0.47);
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    z-index: 1;
    height: 90px;
  }

  .destaques_mobile .galeria1 .layer.show {
    height: 100%;
    background: rgb(0 0 0 / 30%);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .destaques_mobile .galeria1 p.show {
    top: 25%;
    font-size: 20px;
    margin-left: 18px;
  }



  .destaques_mobile .galeria1 p {
    opacity: 1;
    font-size: 16px;
    top: 60%;
    padding-right: 11px;
  }

  .destaques_mobile .galeria1 {
    height: 200px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .content .row .columns {
    padding-right: 0px;
    padding-left: 0px;
  }

}

@media (max-width: 1440px) {
  .galeria1 p.show {
    margin-right: 12%;
    margin-left: 0px;
    font-size: 20px;
  }

  .galeria1 p {
    font-size: 20px;
    margin-right: 12%;
    margin-left: 0px;
  }
}

@media (max-width: 1200px) {
  .galeria1 p.show {
    margin-right: 15%;
    margin-left: 0px;
    font-size: 19px;
    line-height: 25px;
  }

  .galeria1 p {
    font-size: 19px;
    margin-right: 15%;
    margin-left: 0px;
    line-height: 25px;
  }
}

@media (max-width: 1020px) {
  .destaques_mobile .galeria1 p.show {
    font-size: 17px;
    margin-left: 14%;

  }



}









@media (max-width: 850px) {
  .destaques_mobile .galeria1 p.show {
    top: 22%;
    font-size: 19px;
    margin-left: 23px;
  }
}

@media (max-width: 720px) {
  .destaques_mobile .galeria1 .layer {
    height: 105px;
  }
  .destaques_mobile .galeria1 p {
    font-size: 15px;
    top: 53%;
  }
}

/*Responsive - iphone*/
@media (max-width: 767px) {
  .content {
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 60px;
  }

  .content .row .columns {
    padding-right: 0px;
    padding-left: 0px;
  }

  .destaques_mobile .galeria1 {
    height: 170px;
    margin-bottom: 6px;
  }

  .destaques_mobile .galeria1 .layer {
    height: 90px;
  }
  .destaques_mobile .row {
    margin-bottom: -5px;
  }

  .galeria {
    padding-top: 30px;
  }

  .botao_style {
    margin-bottom: 20px;
  }






}

</style>